import { render, staticRenderFns } from "./SupportBubble.vue?vue&type=template&id=17704f1e&scoped=true&"
import script from "./SupportBubble.vue?vue&type=script&lang=js&"
export * from "./SupportBubble.vue?vue&type=script&lang=js&"
import style0 from "./SupportBubble.vue?vue&type=style&index=0&id=17704f1e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17704f1e",
  null
  
)

export default component.exports